import { Directive, TemplateRef } from '@angular/core';

@Directive({
  selector: '[mcListItemActions]'
})
export class ListItemActionsDirective {
  constructor(public templateRef: TemplateRef<any>) { }
}
